import { Maybe } from "lib/types";

export const getDisplayDoctor = (
  firstName: Maybe<string>,
  lastName: Maybe<string>,
  defaultString: string
): string => {
  return firstName && lastName ? `${firstName} ${lastName}` : defaultString;
};
